import "./FadeSection.css";
function FadeSection({ children }) {
	return <div className="fadeIn">{children}</div>;
}

export default FadeSection;
